import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { CssBaseline } from '@material-ui/core';
import css from './indexcss';
import Core from 'domains/core';
import { store } from 'store';
import CSS from 'components/CSS';

ReactDOM.render(
  <Provider store={store}>
    <CSS content={css} />
    <CssBaseline />
    <Core />
  </Provider>,
  document.getElementById('root')
);
